import { useMetrics } from "~/hooks";
import { Metrics } from "~/lib/arrow";
import { useFeatureFlags } from "~/providers/FeatureFlagsProvider";

export const useCriticalExposuresCard = (scopeMrn?: string) => {
  const { isFeatureEnabled } = useFeatureFlags();
  const isMoveTheNeedleFeatureEnabled = isFeatureEnabled("Move the needle");

  const { criticalExposures, isLoading, refetch } = useMetrics({
    entityMrn: scopeMrn || "",
    metricMrns: [Metrics.CriticalExposures],
    skip: !isMoveTheNeedleFeatureEnabled,
  });

  return {
    criticalExposures,
    isLoading,
    refetch,
  };
};
